<div class='experience-ai-advisor-prompt-errors-view-part'>
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="aiPromptErrors()"></grid-content>
</div>